/** Minimal row shape for open/closed checks on GET /api/mrp/incoming rows. */
export type MrpIncomingOpenRow = {
  kind: "po" | "non_po" | "work_order" | "transfer_order" | "transfer_request";
  quantity_remaining: number;
  status: string | null;
  purchase_order_mv_status?: string | null;
  work_order_mv_status?: string | null;
  transfer_status?: string | null;
};

const CLOSED_PO_HEADER_STATUSES = new Set([
  "cancelled",
  "canceled",
  "closed",
  "fullyinvoiced",
  "fully invoiced",
  "fully received",
]);

const CLOSED_WORK_ORDER_STATUSES = new Set([
  "cancelled",
  "canceled",
  "closed",
  "completed",
  "fullyreceived",
  "fully received",
  "fully invoiced",
  "fullyinvoiced",
]);

function normalizedMvStatus(raw: string | null | undefined): string {
  return (raw ?? "").trim().toLowerCase().replace(/_/g, " ").replace(/\s+/g, " ");
}

function mvStatusIsClosed(raw: string | null | undefined, closedSet: Set<string>): boolean {
  const normalized = normalizedMvStatus(raw);
  if (normalized === "") return false;
  return closedSet.has(normalized);
}

/** True when the row still represents open incoming supply (not closed, cancelled, or fully received). */
export function isMrpIncomingRowOpen(row: MrpIncomingOpenRow): boolean {
  if (!Number.isFinite(row.quantity_remaining) || row.quantity_remaining <= 0) {
    return false;
  }
  if (row.status === "received" || row.status === "cancelled") {
    return false;
  }
  if (row.kind === "po" && mvStatusIsClosed(row.purchase_order_mv_status, CLOSED_PO_HEADER_STATUSES)) {
    return false;
  }
  if (row.kind === "work_order" && mvStatusIsClosed(row.work_order_mv_status, CLOSED_WORK_ORDER_STATUSES)) {
    return false;
  }
  if (row.kind === "transfer_order") {
    const status = (row.transfer_status ?? "").trim().toLowerCase();
    if (status === "received" || status === "cancelled") return false;
  }
  if (row.kind === "transfer_request") {
    const status = (row.transfer_status ?? "").trim().toLowerCase();
    if (status === "fulfilled" || status === "cancelled") return false;
  }
  return true;
}
